import PropTypes from "prop-types";
import { translate } from "../../utils/translation";
import isEmpty from "../../validation/is-empty";
import { CustomTooltip } from "../common/Tooltip";
import { InformationTooltipHtml } from "../post-contract-2.0/PostContractButtons.components";

TableHeadingsCell.propTypes = {
  cell: PropTypes.object,
};

export function TableHeadingsCell(props) {
  const { cell } = props;
  const { type } = cell;

  if (type === "NUMBER") {
    return <NumberHeading {...props} />;
  }
  if (type === "DESCRIPTION") {
    return <DescriptionHeading {...props} />;
  }
  if (type === "STATUS") {
    return <NormalHeading {...props} />;
  }
  if (type === "CURRENCY") {
    return <NormalHeading {...props} />;
  }
  if (type === "QUANTITY") {
    return <NormalHeading {...props} />;
  }
  if (type === "PERCENT") {
    return <PercentHeading {...props} />;
  }
  if (type === "DATE") {
    return <PercentHeading {...props} />;
  }
  if (type === "TEXT") {
    return <NormalHeading {...props} />;
  }
  if (type.includes("TOOLTIP")) {
    //heading will be displayed same for all types with tooltips
    return <HeadingWithTooltip {...props} />;
  }
  if (type === "REASONS") {
    return <IconHeading {...props} />;
  }
  if (type === "COMMENTS") {
    return <IconHeading {...props} />;
  }
  if (type === "LINK") {
    return <IconHeading {...props} />;
  }
  if (type === "CRITICAL") {
    return <IconHeading {...props} />;
  }

  if (type === "CHECK") {
    return <NormalHeading {...props} />;
  }

  if (type === "IMAGE") {
    return <NormalHeading {...props} />;
  }
}

NumberHeading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
};

function NumberHeading(props) {
  const { value } = props;
  const { width } = props;

  return (
    <div className="pct-heading-number" style={{ width: width }}>
      <b>{translate(value)}</b>
    </div>
  );
}

DescriptionHeading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
};

function DescriptionHeading(props) {
  const { value } = props;
  const { width } = props;

  return (
    <div className="pct-heading-description" style={{ width: width }}>
      <b>{translate(value)}</b>
    </div>
  );
}

NormalHeading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
};

function NormalHeading(props) {
  const { value } = props;
  const { width } = props;

  return (
    <div className="pct-heading" style={{ width: width }}>
      <b>{translate(value)}</b>
    </div>
  );
}

HeadingWithTooltip.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
  cell: PropTypes.object,
  tooltip: PropTypes.func,
};
function HeadingWithTooltip(props) {
  const { value } = props;
  const { width } = props;
  const { cell } = props;
  const { tooltip } = cell;

  return (
    <div className="pct-heading" style={{ width: width }}>
      <b>{translate(value)}</b>
      {!isEmpty(tooltip) && (
        <CustomTooltip
          tooltipIcon={<InformationTooltipHtml />}
          iconText={""}
          tooltipHtml={tooltip()}
        />
      )}
    </div>
  );
}

IconHeading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
};

function IconHeading(props) {
  const { value } = props;
  const { width } = props;

  return (
    <div className="pct-heading-icon" style={{ width: width }}>
      <b>{translate(value)}</b>
    </div>
  );
}

PercentHeading.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
};

function PercentHeading(props) {
  const { value } = props;
  const { width } = props;

  return (
    <div className="pct-heading-percent" style={{ width: width }}>
      <b>{translate(value)}</b>
    </div>
  );
}
